<template>
  <v-row
    justify="center"
    class="worldwideMask">
      <v-col cols="12" :md="8" :sm="7">
        <PostListTimeline
          class="mt-8"
          :postData="postData"
          :courseId="course.id"
        />
    </v-col>
    <v-col cols="12" :md="4" :sm="5">
      <LatestReviewCard />
      <LatestVlogCard />
    </v-col>
  </v-row>
</template>

<script>
import PostListTimeline from "@/components/Post/PostListTimeline";
import LatestReviewCard from "@/components/Card/LatestReviewCard";
import LatestVlogCard from "@/components/Card/LatestVlogCard";
export default {
  name: "Newsfeed",
  components: { PostListTimeline, LatestReviewCard, LatestVlogCard },
  data() {
    return {
      postData: {},
    };
  },
  computed: {
    course() {
      return this.$store.state.golfcourse.courseDetail;
    },
  },
  methods: {},
};
</script>
